module.exports = __webpack_public_path__ + "static/media/smack.89158ef2.wav";